var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "check_small"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_3086",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_3086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "check_small_2",
    d: "M8.33397 11.604L13.418 6.52099C13.5706 6.36833 13.7476 6.29199 13.949 6.29199C14.1503 6.29199 14.3273 6.36833 14.48 6.52099C14.6326 6.67366 14.709 6.85066 14.709 7.05199C14.709 7.25333 14.6326 7.43033 14.48 7.58299L8.85497 13.208C8.7023 13.3613 8.5253 13.438 8.32397 13.438C8.12264 13.438 7.94564 13.3613 7.79297 13.208L5.52197 10.938C5.3693 10.7847 5.29297 10.6073 5.29297 10.406C5.29297 10.2047 5.3693 10.0277 5.52197 9.87499C5.67464 9.72233 5.85164 9.64599 6.05297 9.64599C6.2543 9.64599 6.4313 9.72233 6.58397 9.87499L8.33397 11.604Z",
    fill: "#0393E4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/CheckIcon.df23ddd5e212d3ec4bf8b639e870cd28.svg";
export { ForwardRef as ReactComponent };